import { createFileRoute } from '@tanstack/react-router'
import { parse } from 'valibot'

import { fetchShipmentCategory } from '@/features/shipment-categories/api'

import { shipmentCategoryParamsSchema } from '../-models/shipment-category-params'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/shipment-categories/$shipmentCategoryId'
)({
  parseParams: (params) => parse(shipmentCategoryParamsSchema, params),
  loader: async ({
    abortController,
    params: { tenantKey, shipmentCategoryId },
    context: { auth }
  }) => {
    return {
      authUser: auth.user,
      shipmentCategory: await fetchShipmentCategory(
        {
          tenantKey,
          shipmentCategoryId
        },
        abortController.signal
      )
    }
  },
  meta: ({ loaderData }) => [
    {
      title: loaderData.shipmentCategory.name
    }
  ]
})
